module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARMAAAC3CAAAAAAUOOUoAAAA3klEQVR42u3dsQmDUBiFUcfIAoJlNhAsbF3BPuAmmUAQ3m52GSJiKRngPsk5I3zlf+G9pgEAAAAAAAAAAAAArublFbUM9TX5fMNKfU32dJNVE0000UQTTTTRRBNNNNFEE0000UQTTTTRRJN/bdJ2YQ97EgAAAMDduLNpookmmmiiiSaaaKKJJppoookmmmiiiSaaaJISf69gq6/Je8sqs+0EAAAAgPvrx7CuviZu1JpoookmmmiiiSaaaKKJJppoookmmmiiiSaapPjj7Nc4hT3tSQAAAAAAAAAAAACcDrIVKZNaDIGtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/black_menu_icon.png
// module id = 1871
// module chunks = 0